export default __webpack_public_path__ + "static/media/Accountability.3acc601a.jpg";